import { isMobile } from 'utils'

export const getStatusName = (statusId, project, allStatuses, columnId = null) => {
    let name = null 

    project.columns.forEach(column => {
        if(column.type == 'STATUS' && ((!columnId && column.is_primary) || (columnId == column.id))){
            column.data && column.data.forEach(status => {
                if(status.status_id == statusId && status.custom_name){
                    name = status.custom_name
                }
            })
        }
    })

    if(!name){
        name = allStatuses[statusId] ? allStatuses[statusId].name : ''
    }

    return name
}

export const getColumns = (project, isPremium, isSingle = false) => {
    let columns = []

    if(isPremium){
        columns = project.columns
    }else{
        columns = project.columns.filter(column => {
            return column.is_primary
        })
    }

    columns.sort((a, b) => {
        return a.order - b.order
    })

    if(isMobile() && !isSingle && columns.length > 3){
        columns.length = 3
    }

    return columns
}


// WEBPACK FOOTER //
// ./src/utils/project.js